import React, { useContext } from "react";
import {  Routes, Route, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";
import Nav2 from "./layouts/nav/index2";
import Footer from "./layouts/Footer";
import ScrollToTop from "./layouts/ScrollToTop";
// import Main from './layouts/Main';
import WalletBar from './layouts/WalletBar';
/// Dashboard
import Home from "./components/Dashboard/Home";
import Finance from "./components/Dashboard/Finance";
import DashboardDark from "./components/Dashboard/DashboardDark";

/// Adminer
import ManageSession from "./components/Adminer/ManageSession";
import AddFees from "./components/Adminer/AddFees";
import ManageFees from "./components/Adminer/ManageFees";
import FeeCollection from "./components/Adminer/FeeCollection";
import ManageSubjects from "./components/Adminer/ManageSubjects";
import ManageClass from "./components/Adminer/ManageClass";
import ExamRoutine from "./components/Adminer/ExamRoutine";

//student
import Students from "./components/Student/Students";
import StudentDetails from "./components/Student/StudentDetails";
import AddNewStudent from "./components/Student/AddNewStudent";

//Teacher
import Teachers from './components/Teacher/Teachers';
import TeachersDetail from './components/Teacher/TeachersDetail';
import AddNewTeacher from './components/Teacher/AddNewTeacher';

//Events
import Events from "./components/Events/Events";

/// File Manager
import FileManager from './components/FileManager/FileManager';
import User from './components/FileManager/User';
import HomeCalendar from './components/FileManager/HomeCalendar';
import Activity from './components/FileManager/Activity';
import FileChat from './components/FileManager/FileChat';
import Uploader from "./components/FileManager/Uploader";


/// App
import AppProfile from "./components/AppsMenu/AppProfile/AppProfile";
import PostDetails from "./components/AppsMenu/AppProfile/PostDetails";
import EditProfile from "./components/AppsMenu/AppProfile/EditProfile";
import Compose from "./components/AppsMenu/Email/Compose/Compose";
import Inbox from "./components/AppsMenu/Email/Inbox/Inbox";
import Read from "./components/AppsMenu/Email/Read/Read";
import Calendar from "./components/AppsMenu/Calendar/Calendar";

/// Product List
import Checkout from "./components/AppsMenu/Shop/Checkout/Checkout";
import Invoice from "./components/AppsMenu/Shop/Invoice/Invoice";
import Customers from "./components/AppsMenu/Shop/Customers/Customers";

/// Charts
import SparklineChart from "./components/charts/Sparkline";
import ChartJs from "./components/charts/Chartjs";
import RechartJs from "./components/charts/rechart";
import ApexChart from "./components/charts/apexcharts";

/// Plugins
import Select2 from "./components/PluginsMenu/Select2/Select2";
// import MainNouiSlider from "./components/PluginsMenu/NouiSlider/MainNouiSlider";
import MainSweetAlert from "./components/PluginsMenu/SweetAlert/SweetAlert";
import Toastr from "./components/PluginsMenu/Toastr/Toastr";
// import JqvMap from "./components/PluginsMenu/JqvMap/JqvMap";
import Lightgallery from "./components/PluginsMenu/Lightgallery/Lightgallery";


/// Widget
import Widget from "./pages/Widget";

/// Table
import SortingTable from "./components/table/SortingTable/SortingTable";
import FilteringTable from "./components/table/FilteringTable/FilteringTable";
// import BootstrapTable from "./components/table/BootstrapTable";

/// Form
import Element from "./components/Forms/Element/Element";
import Wizard from "./components/Forms/Wizard/Wizard";
import CkEditor from "./components/Forms/CkEditor/CkEditor";
import Pickers from "./components/Forms/Pickers/Pickers";
import FormValidation from "./components/Forms/FormValidation/FormValidation";

/// Pages  

import LockScreen from "./pages/LockScreen";
import Error400 from "./pages/Error400";
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import Error500 from "./pages/Error500";
import Error503 from "./pages/Error503";
import { ThemeContext } from "../context/ThemeContext";
import Enrollment from "./components/Adminer/Enrollment";
import Attendance from "./components/Student/Attendance";
import Grading from "./components/Student/Grading";
import Assessment from "./components/Adminer/Assessment";
import PedagogicTasks from "./components/Teacher/PedagogicTasks";
import Transcript from "./components/Student/Transcript";
import Timetable from "./components/Teacher/Timetable";
import CourseCompletion from "./components/Certificates/CourseCompletion";
import Bonafide from "./components/Certificates/Bonafide";
import Transfer from "./components/Certificates/Transfer";
import RollAssignment from "./components/Adminer/RollAssignment";
import ManageEvents from "./components/Events/ManageEvents";
import EventCalendar from "./components/Events/EventCalendar";
import Notifications from "./components/Events/Notifications";
import Volunteer from "./components/Events/Volunteer";
import SchoolProfile from "./components/Dashboard/SchoolProfile";
import ProvisionalCertificate from "./components/Certificates/ProvisionalCertificate";


const Markup = () => {
  const routhPath = [

    //School Profile
    {url: "school-profile", component: <SchoolProfile />},
    // Adminer 
    {url: "finance", component: <Finance/>},
    {url: "session", component: <ManageSession/>},
    {url: "new-fee", component: <AddFees/>},
    {url: "enrollment", component: <Enrollment/>},
    {url: "roll-assignment", component: <RollAssignment/>},
    {url: "fee-management", component: <ManageFees/>},
    {url: "tuition", component: <FeeCollection/>},
    {url: "manage-subject", component: <ManageSubjects/>},
    {url: "manage-class", component: <ManageClass/>},
    {url: "exam", component: <ExamRoutine/>},
    {url: "assessment", component: <Assessment/>},

    //Certifiate section
    {url: "course-completion", component: <CourseCompletion />},
    {url: "bonafide-certificate", component: <Bonafide />},
    {url: "transfer-certificate", component: <Transfer />},
    {url: "provisional-certificate", component: <ProvisionalCertificate />},

    {url: "student", component: <Students/>},
    {url: "transcript", component: <Transcript/>},
    {url: "attendance", component: <Attendance/>},
    {url: "student-detail", component: <StudentDetails/>},
    {url: "add-student", component: <AddNewStudent/>},
    {url: "grading", component: <Grading/>},
    {url: "teacher", component: <Teachers/>},
    {url: "teacher-detail", component: <TeachersDetail/>},
    {url: "add-teacher", component: <AddNewTeacher/>},
    {url: "pedagogic-tasks", component: <PedagogicTasks/>},//Teachers assigned tasks list
    {url: "scheduled-classes", component: <Timetable/>},//Teachers scheduled classes
   
    {url: "user", component: <User/>},
    {url: "activity", component: <Activity/>},
    {url: "calendar", component: <HomeCalendar/>},
    //App Profile
    {url: "app-profile", component: <AppProfile/>},
    {url: "post-details", component: <PostDetails/>},
    {url: "edit-profile", component: <EditProfile/>},
    {url: "app-calender", component: <Calendar/>},
    //App -> shops
   
    {url: "ecom-checkout", component: <Checkout/>},
    {url: "ecom-invoice", component: <Invoice/>},
    {url: "ecom-customers", component: <Customers/>},
    //Charts
    {url: "chart-apexchart", component: <ApexChart/>},
    {url: "chart-rechart", component: <RechartJs/>},
    {url: "chart-chartjs", component: <ChartJs/>},
    {url: "chart-sparkline", component: <SparklineChart/>},    

    //Events
    {url: "events", component: <Events/>},    
    {url: "manage-events", component: <ManageEvents/>},    
    {url: "event-calendar", component: <EventCalendar/>},    
    {url: "notifications", component: <Notifications/>},    
    {url: "volunteer", component: <Volunteer/>},    

    // file uploader 
    {url: "uploader", component: <Uploader />},    

    //Plugins
    { url: "uc-select2", component: <Select2/> },
    { url: "uc-toastr", component: <Toastr/> },  
    { url: "uc-lightgallery", component: <Lightgallery/> }, 
    { url: "uc-sweetalert", component: <MainSweetAlert/> }, 
    { url: "form-element", component: <Element/> },
    { url: "form-wizard", component: <Wizard/> },
    { url: "form-ckeditor", component: <CkEditor/> },
    { url: "form-validation", component: <FormValidation/> },
    //widget
    { url: "widget", component: <Widget/> },  
    /// table
	  { url: 'table-filtering', component: <FilteringTable/> },
    { url: 'table-sorting', component: <SortingTable/> },
    // { url: "table-bootstrap-basic", component: <BootstrapTable/> },  
    { url: "form-pickers", component: <Pickers/> },  
    
  ] 
 
  return (
    <>
      <Routes>                    
          <Route path='/page-error-400' element={<Error400 />} />
          <Route path='/page-error-403' element={<Error403 />} />
          <Route path='/page-error-404' element={<Error404 />} />
          <Route path='/page-error-500' element={<Error500 />} />
          <Route path='/page-error-503' element={<Error503 />} />     
          <Route path='/page-lock-screen' element={<LockScreen />} />     
            <Route element={<Layout1 />}>
              <Route path='/' exact element={<Home/>} />
              <Route path='/dashboard' exact element={<Home/>} />              
              <Route path='/dashboard-dark' exact element={<DashboardDark/>} />                            
            </Route>           
              <Route element={<Layout2 />}>							        
                { routhPath.map((data, i) => (
                  <Route key={i} exact path={`/${data.url}`} element={data.component} />
                ))}     
            </Route>  
                            
              <Route element={<Layout5 />}>	    
                <Route path='/file-manager' exact element={<FileManager/>} />               
                <Route path='/chat' exact element={<FileChat/>} />
                <Route path='/email-compose' exact element={<Compose/>} />
                <Route path='/email-inbox' exact element={<Inbox/>} />
                <Route path='/email-read' exact element={<Read/>} />  
                <Route path='/uploader' exact element={<Uploader />} />  
              </Route> 
              
				</Routes>        
	    <ScrollToTop />
    </>
  );
};

function Layout1(){
  const {  sidebariconHover } = useContext(ThemeContext);
  const sideMenu = useSelector(state => state.sideMenu);
  return(
    
      <div id="main-wrapper" className={`wallet-open active show ${sidebariconHover ? "iconhover-toggle": ""} ${ sideMenu ? "menu-toggle" : ""}`}>                
          <Nav2 />
            <div className="content-body" style={{ minHeight: window.screen.height + 20 }}>
              <div className="container-fluid"> 
                <Outlet />
              </div>  
            </div> 
            <Footer changeFooter="footer-outer"/> 
            <WalletBar /> 
          
      </div>            
    
  )
}

function Layout2(){
  const sideMenu = useSelector(state => state.sideMenu);
  const {  sidebariconHover } = useContext(ThemeContext);
  return(    
    <div id="main-wrapper" className={`show ${sidebariconHover ? "iconhover-toggle": ""} ${ sideMenu ? "menu-toggle" : ""}`}>           
        <Nav />
        <div className="content-body" style={{ minHeight: window.screen.height + 20 }}>
          <div className="container-fluid">							        
            <Outlet />							        
          </div>                        
        </div>  
        <Footer  changeFooter="out-footer style-2"/>           
    </div>  
    
  )
}



function Layout5(){
  const sideMenu = useSelector(state => state.sideMenu);
  const {  sidebariconHover } = useContext(ThemeContext);
  return(
    <div id="main-wrapper" className={`show ${sidebariconHover ? "iconhover-toggle": ""} ${ sideMenu ? "menu-toggle" : ""}`}>  	      
          <Nav />
          <div className="content-body message-body mh-auto">
            <div className="container-fluid mh-auto p-0">   
              <Outlet />
            </div>
          </div>
    </div>
  )
}


export default Markup;